import React from "react";

const PrivacyPolicy = () => (
  <div style={{ maxWidth: 800, margin: "2rem auto", padding: "1rem" }}>
    <h1>Privacy Policy</h1>
    <p>
      This Privacy Policy explains how we collect, use, and protect your information when you use our app and website, in accordance with the General Data Protection Regulation (GDPR) and other applicable EU laws.
    </p>
    <h2>Information We Collect</h2>
    <ul>
      <li>Personal information you provide (e.g., name, email, contact details)</li>
      <li>Usage data and analytics</li>
      <li>Media and files you upload</li>
      <li>Device and log information</li>
    </ul>
    <h2>Legal Basis for Processing</h2>
    <ul>
      <li>We process your personal data based on your consent, to fulfill our contract with you, and to comply with legal obligations.</li>
    </ul>
    <h2>How We Use Your Information</h2>
    <ul>
      <li>To provide and improve our services</li>
      <li>To communicate with you</li>
      <li>To comply with legal obligations</li>
      <li>To prevent fraud and ensure security</li>
    </ul>
    <h2>Data Protection</h2>
    <p>
      We implement industry-standard security measures to protect your data. We do not sell your personal information to third parties. Data is stored securely and only accessible to authorized personnel.
    </p>
    <h2>Data Retention</h2>
    <p>
      We retain your personal data only as long as necessary for the purposes described in this policy, or as required by law.
    </p>
    <h2>Your Rights (GDPR)</h2>
    <ul>
      <li>You have the right to access, correct, or delete your personal data</li>
      <li>You can withdraw your consent at any time</li>
      <li>You have the right to data portability and to restrict or object to processing</li>
      <li>Contact us at support@example.com for privacy-related requests</li>
      <li>You have the right to lodge a complaint with your local data protection authority</li>
    </ul>
    <h2>International Data Transfers</h2>
    <p>
      If your data is transferred outside the European Economic Area (EEA), we ensure appropriate safeguards are in place as required by law.
    </p>
    <h2>Children's Privacy</h2>
    <p>
      Our app is not intended for children under 13. We do not knowingly collect personal data from children under 13.
    </p>
    <h2>Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Please review it periodically. We will notify you of significant changes.
    </p>
    <h2>Contact</h2>
    <p>
      If you have any questions about this Privacy Policy or your rights, please contact us at hi@rareml.ai.
    </p>
  </div>
);

export default PrivacyPolicy;